import React, { useEffect, useRef, useState } from "react";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop"
import ThemedLayout from "components/atoms/ThemedLayout"
import i18n from "utils/i18n"
import PrivacyTab from './_tabs/privacy'
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import FooterBar from 'components/organisms/FooterBar'
import { FooterStyles } from 'styles/components/organisms/Footer'
import { FormStatus } from 'utils/constants/form-constants';
import FormSubmitButton from 'components/atoms/FormSubmitButton'
import LoadingComponent from 'components/atoms/Loading'
import { TESTID } from '_shared/config/testID'


const HomeMorePrivacyScene = () => {
	
	const layoutRef = useRef()
	
	const [ loading, setLoading ] = useState( true );
	const [ formStatus, setFormStatus ] = useState( FormStatus.NONE );
	
	useEffect( () => {
		EmployeeValues.resetEmployee();
		setLoading( false )
	}, [] );
	
	const submitForm = () => {
		EmployeeValues.submitEmployee( setFormStatus );
	}
	
	let submitButton = (
		<FormSubmitButton
			onPress={ submitForm }
			formStatus={ formStatus }
			formStatusCallback={ setFormStatus }
			style={ [ FooterStyles.button, FooterStyles.buttonFill ] }>
				
			{ i18n.t( 'buttons.save' ) }
		</FormSubmitButton>
	);
	
	let content = <LoadingComponent />
	let footer = null;
	
	if( !loading ) {
		content = (
			<PrivacyTab />
		)
		
		footer = (
			<FooterBar
				buttons={ submitButton }
				onHeightCallback={ layoutRef.current?.setFooterHeight }
			/>
		);
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t( 'titles.more_privacy') }
				testID={ TESTID.HOME.MORE.SCREENS.PRIVACY}>
				
				{ content }
			</ThemedLayout>
			
			{ footer }
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeMorePrivacyScene;
